import { LmIconFilledEditBookOpen, LmIconOutlineEditBookOpen } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconGia = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineEditBookOpen {...rest} /> : <LmIconFilledEditBookOpen {...rest} />;

export default IconGia;
